import stripeService from './stripeService'

export default stripeService
